<div class="title-container">
  <svg-icon class="icon" src="/assets/icons/question-filled-circle.svg"></svg-icon>
  <h1 class="title">Help</h1>
</div>
<p class="description">Need help now? Access support and resources below.</p>
<ng-content></ng-content>
<div class="help-accordion-container">
  <kp-accordion>
    <kp-accordion-group class="accordion-technical-support" [id]="'purposefulTechnicalSupport'">
      <h3 class="accordion-title" acc-open>{{ productName }} Technical Support</h3>
      <!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
      <!-- prettier-ignore -->
      <span acc-collapsible>
        Let us know how we can help. Get in touch with technical support anytime by emailing
        <a
          class="help-link"
          href="mailto:support@kumanu.com?Subject={{ productName }}%20Support%20Request"
          target="_blank">
          support@kumanu.com
        </a>.
      </span>
    </kp-accordion-group>
    <kp-accordion-group [id]="'crisisLifeline'" [initialStateOpen]="false">
      <h3 class="accordion-title" acc-open>Suicide and Crisis Lifeline</h3>
      <!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
      <!-- prettier-ignore -->
      <span acc-collapsible>
        If you are thinking about suicide or self-harm, are worried about a friend or loved one, or need some emotional
        support, call or text the Suicide & Crisis Lifeline at
        <a class="help-link" [href]="'+1-988' | clickableTelephoneNumber" target="_blank">988</a>.
        You can also chat online at
        <a class="help-link" href="https://988lifeline.org/" target="_blank">988lifeline.org</a>.
        Lifeline is free, confidential, and available 24/7 across the United States.
      </span>
    </kp-accordion-group>
    <kp-accordion-group [id]="'domesticViolenceHotline'" [initialStateOpen]="false">
      <h3 class="accordion-title" acc-open>National Domestic Violence Hotline</h3>
      <!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
      <!-- prettier-ignore -->
      <span acc-collapsible>
        If you or anyone you know are in crisis or danger, or need immediate assistance, please use the following
        resource to get help in the United States. National Domestic Violence Hotline,
        <a class="help-link" [href]="'+1-800-799-7233' | clickableTelephoneNumber" target="_blank">800-799-7233</a>.
      </span>
    </kp-accordion-group>
    <kp-accordion-group [id]="'distressHelpline'" [initialStateOpen]="false">
      <h3 class="accordion-title" acc-open>Disaster Distress Helpline</h3>
      <!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
      <!-- prettier-ignore -->
      <span acc-collapsible>
        If you or anyone you know has experienced a disaster, contact the Disaster Distress Helpline. The Helpline is a
        national hotline available 24/7, 365 days a year, dedicated to providing immediate crisis counseling for people
        who are experiencing emotional distress related to any natural or human-caused crisis or disaster. Disaster
        Distress Helpline,
        <a class="help-link" [href]="'+1-800-985-5990' | clickableTelephoneNumber" target="_blank">800-985-5990</a>.
      </span>
    </kp-accordion-group>
    <kp-accordion-group [id]="'hungerHotline'" [initialStateOpen]="false">
      <h3 class="accordion-title" acc-open>National Hunger Hotline</h3>
      <!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
      <!-- prettier-ignore -->
      <span acc-collapsible>
        If you or someone close to you is currently experiencing hunger, call the National Hunger Hotline. This hotline
        can help provide information about local food pantries, government programs, and other organizations. National
        Hunger Hotline,
        <a class="help-link" [href]="'+1-866-348-6479' | clickableTelephoneNumber" target="_blank">866-348-6479</a>.
      </span>
    </kp-accordion-group>
  </kp-accordion>
</div>
<p class="version">
  Version {{ appVersion }}
  <span class="revision">(revision: {{ version }}-{{ revision }})</span>
</p>
<p class="copyright">
  <kp-copyright
    [includeProMedica]="false"
    [includePromedicaJointTrademark]="isResourceful"
    [includeKumanuTrademark]="isPurposeful"></kp-copyright>
</p>
